import { CalendarEvent } from '@/services/api-providers/CalendarServiceProvider';

/**
 * View mode for the MeetingsPage — list (existing table) or calendar (week grid).
 */
export type MeetingsViewMode = 'list' | 'calendar';

/**
 * A CalendarEvent enriched with CSS positioning data for the week grid.
 */
export interface PositionedEvent {
  event: CalendarEvent;
  /** CSS top in pixels, relative to the time grid container */
  top: number;
  /** CSS height in pixels */
  height: number;
  /** 0-based column index within an overlap group */
  columnIndex: number;
  /** Total number of columns in this overlap group */
  totalColumns: number;
}

/**
 * Events grouped by day for the week grid.
 * Key: ISO date string 'YYYY-MM-DD'
 */
export type EventsByDay = Record<string, PositionedEvent[]>;

/**
 * A single day column in the week view.
 */
export interface CalendarDay {
  /** ISO date string 'YYYY-MM-DD' */
  dateKey: string;
  /** Day of month (1-31) */
  dayOfMonth: number;
  /** Short weekday name ('Mon', 'Tue', ...) */
  weekday: string;
  /** Whether this day is today */
  isToday: boolean;
  /** Full Date object (start of day, local time) */
  date: Date;
}

/**
 * localStorage key for persisting the meetings view mode preference.
 */
export const MEETINGS_VIEW_MODE_KEY = 'meetingsViewMode';
